<template>
  <transition name="slide">
    <div v-if="shouldShow" class="fixed bottom-[2%] left-[2%] z-jiji cursor-pointer" @click="onClick">
      <p class="jiji w-fit rounded border bg-black1 px-2 py-1 text-xs text-white">👨‍🦳 {{ jijiText }}</p>
    </div>
  </transition>
</template>

<script setup lang="ts">
interface Props {
  env?: string;
}

const props = withDefaults(defineProps<Props>(), {
  env: 'development',
});

const jijiText = computed<string>(() => {
  if (props.env === 'local') return 'ローカル環境';
  if (props.env === 'development') return '検証環境';
  if (props.env === 'staging') return 'ステージング環境';
  return '';
});

const showJiji = ref<boolean>(true);

const onClick = () => {
  showJiji.value = false;
};

const shouldShow = computed<boolean>(() => (props.env === 'local' || props.env === 'development' || props.env === 'staging') && showJiji.value);
</script>

<style lang="scss" scoped>
.jiji {
  &:hover {
    -webkit-animation: fluffy 0.8s linear 0s 1;
    animation: rumble 0.12s linear infinite;
  }
}

.slide-enter-active,
.slide-leave-active {
  transform: translate(0px, 0px);
  transition: transform 3s cubic-bezier(0, 0, 0.2, 1) 3ms;
}

.slide-enter,
.slide-leave-to {
  transform: translateY(200px) translateY(0px);
}

@keyframes rumble {
  0% {
    transform: rotate(0deg) translate(0, 0);
  }
  12.5% {
    transform: rotate(0.8deg) translate(1px, -1px);
  }
  25% {
    transform: rotate(0.8deg) translate(0px, 1px);
  }
  37.5% {
    transform: rotate(0.8deg) translate(-1px, 0);
  }
  50% {
    transform: rotate(0deg) translate(0, 0);
  }
  62.5% {
    transform: rotate(-0.8deg) translate(1px, 0);
  }
  75% {
    transform: rotate(-0.8deg) translate(0, 1px);
  }
  87.5% {
    transform: rotate(-0.8deg) translate(-1px, -1px);
  }
  100% {
    transform: rotate(0deg) translate(0, 0);
  }
}
</style>
